import { FC, useCallback } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { addNewSharedCost } from "@/store/dimensions/dimensionsSlice";
import { generateEmptySharedCost } from "@/components/pages/dimensions/utils/helpers/shared-cost/generateEmptySharedCost";
import { dimensionCategoriesIdsSelector } from "@/store/dimensions/selectors/slice-data/categories/dimensionCategoriesIdsSelector";
import { dimensionSharedCostsLengthSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsLengthSelector";
import { dimensionsSharedCostsDataIsInvalidSelector } from "@/store/dimensions/selectors/options/shared-costs/dimensionsSharedCostsDataIsInvalidSelector";

export const AddAllocationRuleButton: FC = () => {
  const dispatch = useAppDispatch();
  const categoriesIds = useAppSelector(dimensionCategoriesIdsSelector);
  const rulesCount = useAppSelector(dimensionSharedCostsLengthSelector);
  const disabled = useAppSelector(dimensionsSharedCostsDataIsInvalidSelector);

  const addSharedCostHandler = useCallback(() => {
    dispatch(
      addNewSharedCost(generateEmptySharedCost(categoriesIds, rulesCount)),
    );
  }, [dispatch, categoriesIds, rulesCount]);

  return (
    <Button
      variant="outlined"
      disabled={disabled}
      startIcon={<AddIcon />}
      onClick={addSharedCostHandler}
      sx={{ alignSelf: "start" }}
    >
      Add Allocation Rule
    </Button>
  );
};
